import { IHomePageSectionsArrangementQuery } from "../../models/arrange_sections_page_home/query";
import { IHomePageSectionsArrangementList } from "../../models/arrange_sections_page_home/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { HomePageSectionsArrangementListLoading, IInternalState } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: { loading: HomePageSectionsArrangementListLoading | HomePageSectionsArrangementListLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IHomePageSectionsArrangementList> } }
  | QueryAction<IHomePageSectionsArrangementQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
